import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import MainLayout from "../components/MainLayout";
import Home from "../pages/Home";
import Terms from "../pages/Terms";
import Privacy from "../pages/Privacy";
import Disclaimer from "../pages/Disclaimer";
import Childsafety from "../pages/Childsafety";

// Admin
import Login from "../admin/pages/Login";
import Dashboard from "../admin/pages/Dashboard";
import AdminMainLayout from "../admin/common/AdminMainLayout";
import Users from "../admin/pages/new/Users";
import UserDetails from "../admin/pages/new/UserDetails";
import Articles from "../admin/pages/new/Articles";
import NewArticle from "../admin/pages/new/NewArticle";
import Events from "../admin/pages/new/Events";
import AddEvent from "../admin/pages/new/AddEvent";
import Feedback from "../admin/pages/new/Feedback";
import Notifications from "../admin/pages/new/Notifications";
import Settings from "../admin/pages/new/Settings";
import EditArticle from "../admin/pages/new/EditArticle";
import EditEvent from "../admin/pages/new/EditEvent";
import Moderation from "../admin/pages/new/Moderation";
import Posts from "../admin/pages/new/Posts";

const Allroutes = () => {
  return (
    <Router basename={"/"}>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/home" element={<Home />} />
        <Route
          exact
          path="/terms-conditions"
          element={
            <MainLayout>
              <Terms />
            </MainLayout>
          }
        />
        <Route
          exact
          path="/privacy-policy"
          element={
            <MainLayout>
              <Privacy />
            </MainLayout>
          }
        />
        <Route
          exact
          path="/disclaimer"
          element={
            <MainLayout>
              <Disclaimer />
            </MainLayout>
          }
        />

        <Route
          exact
          path="/child-safety"
          element={
            <MainLayout>
              <Childsafety />
            </MainLayout>
          }
        />

        {/* Admin */}
        <Route exact path="/admin" element={<Login />} />
        <Route exact path="/admin/login" element={<Login />} />
        <Route
          exact
          path="/admin/dashboard"
          element={
            <AdminMainLayout title={"Dashboard"}>
              <Dashboard />
            </AdminMainLayout>
          }
        />
        <Route
          exact
          path="/admin/users"
          element={
            <AdminMainLayout title={"All Users"}>
              <Users />
            </AdminMainLayout>
          }
        />
        <Route
          exact
          path="/admin/user-details/:id"
          element={
            <AdminMainLayout title={"User Details"}>
              <UserDetails />
            </AdminMainLayout>
          }
        />
         <Route
          exact
          path="/admin/articles"
          element={
            <AdminMainLayout title={"All Articles"}>
              <Articles />
            </AdminMainLayout>
          }
        />
         <Route
          exact
          path="/admin/add-new-article"
          element={
            <AdminMainLayout title={"New Article"}>
              <NewArticle />
            </AdminMainLayout>
          }
        />
         <Route
          exact
          path="/admin/edit-article/:id"
          element={
            <AdminMainLayout title={"Update Article"}>
              <EditArticle />
            </AdminMainLayout>
          }
        />
        <Route
          exact
          path="/admin/edit-event/:id"
          element={
            <AdminMainLayout title={"Update Event"}>
              <EditEvent />
            </AdminMainLayout>
          }
        />
        <Route
          exact
          path="/admin/events"
          element={
            <AdminMainLayout title={"All Events"}>
              <Events />
            </AdminMainLayout>
          }
        />
        <Route
          exact
          path="/admin/add-new-event"
          element={
            <AdminMainLayout title={"New Event"}>
              <AddEvent />
            </AdminMainLayout>
          }
        />
        <Route
          exact
          path="/admin/posts"
          element={
            <AdminMainLayout title={"Posts"}>
              <Posts />
            </AdminMainLayout>
          }
        />
        <Route
          exact
          path="/admin/moderation"
          element={
            <AdminMainLayout title={"Moderation"}>
              <Moderation />
            </AdminMainLayout>
          }
        />
        <Route
          exact
          path="/admin/feedbacks"
          element={
            <AdminMainLayout title={"All Feedbacks"}>
              <Feedback />
            </AdminMainLayout>
          }
        />
         <Route
          exact
          path="/admin/notifications"
          element={
            <AdminMainLayout title={"All Push Notifications"}>
              <Notifications />
            </AdminMainLayout>
          }
        />
        <Route
          exact
          path="/admin/settings"
          element={
            <AdminMainLayout title={"Settings"}>
              <Settings />
            </AdminMainLayout>
          }
        />
      </Routes>
    </Router>
  );
};

export default Allroutes;
